import { ReactNode } from 'react';
import { Thead, Tr, Th as CKTh, TableColumnHeaderProps } from '@chakra-ui/react';
import { Colors, Icon } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import SortableHeader from 'components/layout/Table/SortableHeader';
import { useSortedCompanies, COMPANY_TABLE_HEADINGS } from 'hooks/useSortedCompanies';
import { Z_INDEX_DICT } from 'utils/constants/zIndex';

const tableHeader = {
  fontWeight: '600',
  fontSize: '10px',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: 'brand.dark-green',
};

const companyNameStyle = {
  justifyContent: 'flex-start',
  alignItems: 'center',
  columnGap: 'padding_4',
};

const stickyHeaderStyle = {
  '>tr>th': {
    position: 'sticky',
    top: '0',
    backgroundColor: Colors.White,
    zIndex: Z_INDEX_DICT.LEAD_TABLE_HEADER,
  },
};

const projectsStyle = { textAlign: 'right' };

const COLUMN_WIDTH = {
  SAVE: '60px',
  NAME: '20%',
  TYPE: '14%',
  LOCATIONS: '18%',
  WEBSITE: '12%',
  ACTIVE_PROJECTS: '18%',
  COMPLETED_PROJECTS: '18%',
};

type ThProps = {
  colWidth?: string;
  children: ReactNode;
  sx?: TableColumnHeaderProps['sx'];
};

const Th = ({ colWidth = 'auto', sx = {}, children }: ThProps) => {
  return (
    <CKTh width={colWidth} sx={{ ...tableHeader, ...sx }}>
      {children}
    </CKTh>
  );
};

const TableHeader = () => {
  const { heading, sortByHeading, isSorted } = useSortedCompanies();

  return (
    <Thead sx={stickyHeaderStyle}>
      <Tr>
        <Th colWidth={COLUMN_WIDTH.SAVE}>Save</Th>
        <Th colWidth={COLUMN_WIDTH.NAME}>
          <FlexRow sx={companyNameStyle}>
            <Icon name={Icon.Name.CompanyBuilding} />
            <SortableHeader
              onClick={() => {
                sortByHeading(COMPANY_TABLE_HEADINGS.COMPANY_NAME);
              }}
              headingKey={COMPANY_TABLE_HEADINGS.COMPANY_NAME}
              currentHeading={heading}
              isSorted={isSorted}
              label="Company Name"
            />
          </FlexRow>
        </Th>
        <Th colWidth={COLUMN_WIDTH.TYPE}>
          <SortableHeader
            onClick={() => {
              sortByHeading(COMPANY_TABLE_HEADINGS.TYPE);
            }}
            headingKey={COMPANY_TABLE_HEADINGS.TYPE}
            currentHeading={heading}
            isSorted={isSorted}
            label="Type"
          />
        </Th>
        <Th colWidth={COLUMN_WIDTH.LOCATIONS}>Locations</Th>
        <Th colWidth={COLUMN_WIDTH.WEBSITE}>Website</Th>
        <Th colWidth={COLUMN_WIDTH.ACTIVE_PROJECTS} sx={projectsStyle}>
          <SortableHeader
            onClick={() => {
              sortByHeading(COMPANY_TABLE_HEADINGS.ACTIVE_PROJECTS);
            }}
            headingKey={COMPANY_TABLE_HEADINGS.ACTIVE_PROJECTS}
            currentHeading={heading}
            isSorted={isSorted}
            label="Active Projects"
          />
        </Th>
        <Th colWidth={COLUMN_WIDTH.COMPLETED_PROJECTS} sx={projectsStyle}>
          Completed Projects
        </Th>
      </Tr>
    </Thead>
  );
};

export default TableHeader;
